import React from 'react';

const langs = [
    {
        type: 'English',
        value: 'en'
    },
    {
        type: 'Deutsch',
        value: 'de'
    },
    {
        type: 'French',
        value: 'fr'
    },
    {
        type: 'Italian',
        value: 'it'
    }
];

export class DropDownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    generateDropDown = () => {
        switch (this.props.dropDownType) {
            case 'add':
                return (
                    <select onChange={this.props.handler} name="dropDownAdd" id="dropDownMenuAdd" defaultValue="">
                        <option value="">{this.props.placeholder}</option>
                        {langs.map(lang => (
                            <option key={lang.value} value={lang.value}>
                                {lang.type}
                            </option>
                        ))}
                    </select>
                );
            case 'edit':
                return (
                    <select onChange={this.props.handler} name="dropDownEdit" id="dropDownMenuEdit" value={this.props.language}>
                        <option value="">{this.props.placeholder}</option>
                        {langs.map(lang => {
                            return (
                                <option key={lang.value} value={lang.value}>
                                    {lang.type}
                                </option>
                            );
                        })}
                    </select>
                );
            default:
            
        }
    };

    render() {
        return (
            <div className={`formDropDown ${this.props.extraClasses}`}>
                <label> {this.props.label} </label>
                <div className="dropDownWrapper">{this.generateDropDown()}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/customModules/Common/form/DropDownMenu.js